import { Button, Modal, ModalContent } from '@strivelabs/ui-core/v2';

export interface DeleteDialogProps {
  open: boolean;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/** Confirms deleting a conversation. Deletion is not recoverable. */
export function DeleteDialog({ open, isDeleting, onCancel, onConfirm }: DeleteDialogProps) {
  if (!open) return null;

  return (
    <Modal open onOpenChange={next => !next && onCancel()}>
      <ModalContent className="w-[420px] p-5" ariaLabel="Delete chat">
        <h2 className="text-v2-lg font-semibold text-v2-foreground">Delete chat?</h2>
        <p className="mt-1 text-v2-sm text-v2-muted-foreground">
          This conversation and its history will be removed. This cannot be undone.
        </p>
        <div className="mt-5 flex justify-end gap-2">
          <Button type="button" variant="ghost" size="sm" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            type="button"
            size="sm"
            onClick={onConfirm}
            state={isDeleting ? 'loading' : undefined}
            className="bg-v2-destructive text-v2-destructive-foreground hover:bg-v2-destructive/90"
          >
            Delete
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
}
